module.exports = __webpack_public_path__ + "img/temp-bg.247b53b1.jpg";